const WAREHOUSE_ROUTES = {
    ADD_WAREHOUSE: 'warehouse/add',
    GET_WAREHOUSE: 'warehouse/list',
    UPDATE_WAREHOUSE: 'warehouse/update',
    DELETE_WAREHOUSE: 'warehouse/delete',

}
export default WAREHOUSE_ROUTES;